<template>
  <Layout>
    <h3>
      {{ verboseNamePlural }}
    </h3>
    <b-card class="full-height">
      <b-row>
        <b-col cols="2">
          <h-e-rectangle :title="`${rows} ${verboseNamePlural}`" class="d-flex" />
        </b-col>
        <b-col cols="7" />
        <b-col cols="3">
          <h-f-design-search-field
            v-model="searchInput"
            placeholder="Rechercher (séparez par des virgules pour chercher plusieurs factures)"
          />
          <small v-if="searchInput && searchInput.includes(',')" class="text-muted">
            <i class="mdi mdi-information-outline"></i> Recherche de {{ searchTerms.length }} élément(s)
          </small>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col cols="6" class="d-flex align-items-start">
          <h-b-action
            text="Filtres"
            icon="bx bx-slider-alt"
            :positive="false"
            @click.native="sliderLeftActive = !sliderLeftActive"
          />
          <h-b-action
            v-if="!nearToExpiration && ressource === 'invoices'"
            text="Factures arrivant à échéance"
            class="ml-2"
            icon="mdi mdi-eye-outline"
            :positive="false"
            @click.native="nearToExpiration = !nearToExpiration"
          />
          <h-b-action
            v-if="nearToExpiration && ressource === 'invoices'"
            text="Toutes les factures"
            class="ml-2"
            icon="bx bx-undo"
            :positive="false"
            @click.native="nearToExpiration = !nearToExpiration"
          />
        </b-col>
        <b-col cols="6" class="d-flex align-items-start justify-content-end">
          <h-b-action
            v-if="add"
            :positive="false"
            icon="mdi mdi-plus"
            text="Ajouter"
            color="primary"
            @click.native="goToTransactionCreate()"
          />
          <h-b-action
            v-if="numberSelected && ressource === 'invoices' && manyInvoicesPayment"
            class="ml-2"
            :positive="false"
            icon="bx bx-money"
            text="Valider ces factures"
            color="primary"
            @click.native="valideInvoiceStatus()"
          />
          <h-b-action
            v-if="numberSelected && ressource === 'invoices' && is_sales"
            class="ml-2"
            :positive="false"
            icon="bx bx-dollar"
            text="Ajouter un paiement"
            color="success"
            @click.native="openBulkPaymentModal()"
          />
          <h-b-action
            v-if="isMultiSearch && transactions.length > 0 && ressource === 'invoices'"
            class="ml-2"
            :positive="false"
            icon="bx bx-check-circle"
            :text="`Sélectionner les ${transactions.length} résultats`"
            color="info"
            @click.native="selectAllSearchResults()"
          />
          <div
            v-if="ressource === 'invoices' && !manyInvoicesPayment"
            class="d-flex align-items-start justify-content-end ml-2 mt-n4"
          >
            <h-e-spinner size="sm" />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <h-t-table :nb-results="transactions.length" :loaded="loaded" class="sm">
          <template #table-head>
            <h-t-table-header-action v-if="ressource === 'invoices'" side="left">
              <b-form-checkbox
                v-model="selectAll"
                :unchecked-value="false"
                :value="true"
                name="checkbox-1"
                @change="selectedAll()"
              />
            </h-t-table-header-action>
            <h-t-table-header>PÉRIODIQUE</h-t-table-header>
            <h-t-table-header v-if="'number' in transactionClass.get_form()"> NUMÉRO</h-t-table-header>
            <h-t-table-header v-if="'organization' in transactionClass.get_form()">
              {{ $route.params.sales === 'true' ? 'CLIENT' : 'FOURNISSEUR' }}
            </h-t-table-header>
            <h-t-table-header v-if="'created_at' in transactionClass.get_form()"> DATE DE CRÉATION</h-t-table-header>
            <h-t-table-header v-if="'expiration_date' in transactionClass.get_form()"
              >DATE D'EXPIRATION
            </h-t-table-header>
            <h-t-table-header v-if="transactionClass.get_form().total_quantity"> QUANTITÉS</h-t-table-header>
            <h-t-table-header v-if="transactionClass.get_form().total_price"> TOTAL</h-t-table-header>
            <h-t-table-header v-if="'status' in transactionClass.get_form()"> STATUT</h-t-table-header>
            <h-t-table-header v-if="ressource === 'invoices'">STATUT DE PAIEMENT</h-t-table-header>
            <h-t-table-header-action> ACTIONS</h-t-table-header-action>
          </template>
          <template #table-body>
            <tr v-for="transaction in transactions" :key="transaction.id" class="cursor-pointer">
              <h-t-table-element-action v-if="ressource === 'invoices'" side="left">
                <b-form-checkbox
                  v-if="transaction.payment_status !== 'paid'"
                  v-model="transaction.selected"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                  @change="selectTransaction(transaction.id)"
                />
              </h-t-table-element-action>
              <h-t-table-element
                >{{ transaction.is_periodic ? `Tous les ${transaction.periodic_day} du mois` : 'Non' }}
              </h-t-table-element>
              <h-t-table-element
                v-if="'number' in transactionClass.get_form()"
                @click.native="goToTransactionDetail(transaction.id)"
                >{{ transaction.number }}
              </h-t-table-element>
              <h-t-table-element
                v-if="'organization' in transactionClass.get_form()"
                @click.native="goToTransactionDetail(transaction.id)"
                >{{ getDistantValue(transaction.organization_object, 'company_name') }}
              </h-t-table-element>
              <h-t-table-element v-if="'expiration_date' in transactionClass.get_form()"
                >{{ transaction.created_at | formatDate }}
              </h-t-table-element>
              <h-t-table-element
                v-if="'expiration_date' in transactionClass.get_form()"
                @click.native="goToTransactionDetail(transaction.id)"
                >{{ transaction.expiration_date | formatDate }}
              </h-t-table-element>
              <h-t-table-element
                v-if="transactionClass.get_form().total_quantity"
                @click.native="goToTransactionDetail(transaction.id)"
                >{{ transaction.total_quantity }}
              </h-t-table-element>
              <h-t-table-element
                v-if="transactionClass.get_form().total_price"
                @click.native="goToTransactionDetail(transaction.id)"
                >{{ transaction.total_price }} €
              </h-t-table-element>
              <h-t-table-element
                v-if="'status' in transactionClass.get_form()"
                @click.native="goToTransactionDetail(transaction.id)"
              >
                <h-e-rectangle
                  color-full
                  :title="formatStatus(transaction.status)"
                  :bg-color="formatColor(transaction.status)"
                />
              </h-t-table-element>

              <h-t-table-element v-if="ressource === 'invoices'" @click.native="goToTransactionDetail(transaction.id)">
                <h-e-rectangle
                  color-full
                  :title="formatPaymentStatus(transaction.payment_status)"
                  :bg-color="formatPaymentColor(transaction.payment_status)"
                />
              </h-t-table-element>
              <h-t-table-element-action>
                <i class="bx bx-down-arrow-circle text-primary" @click="goToTransactionView(transaction)"></i>
                <i
                  v-if="transaction.status !== 'canceled' && transaction.status !== 'ended' && scope(transaction)"
                  class="bx bx-edit-alt text-primary"
                  @click="goToTransactionEdit(transaction.id)"
                ></i>
                <i class="bx bx-duplicate text-primary" @click="duplicateTransaction(transaction.id)"></i>
              </h-t-table-element-action>
            </tr>
          </template>
        </h-t-table>
        <b-row class="mt-3">
          <b-col cols="6" class="d-flex align-items-center">
            <span class="mr-2">Afficher :</span>
            <b-form-select v-model="perPage" :options="perPageOptions" class="w-auto" />
            <span class="ml-2">éléments par page</span>
          </b-col>
          <b-col cols="6">
            <h-e-paging v-model="page" :per-page="perPage" :rows="rows" class="w-100" />
          </b-col>
        </b-row>
      </b-row>
    </b-card>
    <h-f-slider v-if="transactionClass" v-model="sliderLeftActive" title="Filtres" side="left" :footer="false">
      <h-f-filter-wrapper :form-filter="formFilters" :active-filter="activeFilters">
        <h-f-filter
          v-model="activeFilters.organization"
          :number="1"
          :title="$route.params.sales === 'true' ? 'Client' : 'Fournisseur'"
        >
          <h-f-model-multi-taggable
            v-model="formFilters.organization"
            class="w-100"
            :text-choices="['company_name']"
            :base-url="directoryUrl"
            ressource="organizations"
            :additional-request="`&is_active=true${
              $route.params.sales === 'true' ? '&type=client' : '&is_manufacturer=true'
            }`"
          />
        </h-f-filter>
        <h-f-filter v-model="activeFilters.stockage_area" :number="2" title="Lieu de stockage">
          <h-f-model-multi-taggable
            v-model="formFilters.stockage_area"
            class="w-100"
            :text-choices="['name']"
            :base-url="productUrl"
            ressource="stockage-areas"
            additional-request="&is_active=true"
          />
        </h-f-filter>
        <h-f-filter v-model="created_at" :number="3" title="Date de création">
          <h-f-date-filter
            name="created-at"
            :after.sync="formFilters.created_at_after"
            :before.sync="formFilters.created_at_before"
          />
        </h-f-filter>
        <h-f-filter
          v-if="'delivery_date' in transactionClass.get_form()"
          v-model="delivery_date"
          :number="4"
          title="Date de livraison"
        >
          <h-f-date-filter
            name="delivery-date"
            :after.sync="formFilters.delivery_date_after"
            :before.sync="formFilters.delivery_date_before"
          />
        </h-f-filter>
        <h-f-filter v-model="total_quantity" :number="5" title="Quantité de produit">
          <h-f-number-filter
            name="total-quantity"
            :min.sync="formFilters.total_quantity_min"
            :max.sync="formFilters.total_quantity_max"
          />
        </h-f-filter>
        <h-f-filter v-model="activeFilters.status" :number="6" title="Statut">
          <h-f-fields v-model="formFilters.status" class="w-100" :model-select="status" input-type="model-select" />
        </h-f-filter>
        <h-f-filter
          v-if="'total_price' in transactionClass.get_form()"
          v-model="total_price"
          :number="7"
          title="Prix total"
        >
          <h-f-number-filter
            name="total-price"
            :min.sync="formFilters.total_price_min"
            :max.sync="formFilters.total_price_max"
          />
        </h-f-filter>
        <h-f-filter
          v-if="'total_price' in transactionClass.get_form()"
          v-model="sub_total_price"
          :number="8"
          title="Prix totale (hors taxes)"
        >
          <h-f-number-filter
            name="total-price"
            :min.sync="formFilters.sub_total_price_min"
            :max.sync="formFilters.sub_total_price_max"
          />
        </h-f-filter>
      </h-f-filter-wrapper>
    </h-f-slider>

    <!-- Slider pour paiement en masse -->
    <h-f-slider
      v-model="bulkPaymentSliderActive"
      title="Ajouter un paiement"
      :loaded="loadedBulkPayment"
      @clickSubmit="submitBulkPayment"
      @clickCancel="closeBulkPaymentModal"
    >
      <b-alert v-if="selectedTransactions.length" show variant="info" class="mb-3">
        <i class="mdi mdi-information mr-1"></i>
        {{ selectedTransactions.length }} facture(s) sélectionnée(s)
      </b-alert>

      <h-f-fields
        v-model="bulkPaymentForm.payment_date"
        label="Date de paiement*"
        input-type="date"
        :submitted="submittedBulkPayment"
        :invalid="$v.bulkPaymentForm.payment_date.$error"
        :required="!$v.bulkPaymentForm.payment_date.required"
      ></h-f-fields>

      <h-f-fields
        v-model="bulkPaymentForm.payment_method"
        label="Méthode de paiement"
        input-type="model-select"
        :model-select="paymentMethodChoices"
        :submitted="submittedBulkPayment"
      ></h-f-fields>

      <h-f-fields v-model="bulkPaymentForm.note" label="Note" input-type="textarea"></h-f-fields>

      <b-alert show variant="warning" class="mt-3">
        <i class="mdi mdi-alert mr-1"></i>
        Le montant du paiement sera le montant restant à payer de chaque facture.
      </b-alert>
    </h-f-slider>
  </Layout>
</template>

<script>
import { APIRequest, Hk, FunctionHelpers } from '@/node-sdk'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'

import Layout from '../../../layouts/main'

const { Transaction, InvoiceGroup, InvoicePayment } = Hk.Crm
export default {
  name: 'transactions',

  components: {
    Layout,
  },

  validations: {
    bulkPaymentForm: {
      payment_date: { required },
    },
  },
  filters: {
    formatDate(date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY')
    },
  },

  props: {
    transactionClass: {
      type: Object,
      default: () => Transaction,
    },
    verboseName: {
      type: String,
      default: '',
    },
    verboseNamePlural: {
      type: String,
      default: '',
    },
    ressource: {
      type: String,
      default: '',
    },
    additionalParams: {
      type: Object,
      default: () => ({}),
    },
    add: {
      type: Boolean,
      default: true,
    },
    colors: {
      type: Object,
      default: () => {},
    },
    displayPay: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeFilters: {
        created_at_after: false,
        created_at_before: false,
        delivery_date_after: false,
        delivery_date_before: false,
        organization: false,
        status: false,
        stockage_area: false,
        sub_total_price_max: false,
        sub_total_price_min: false,
        total_price_max: false,
        total_price_min: false,
        total_quantity_max: false,
        total_quantity_min: false,
        number: false,
      },
      created_at: false,
      delivery_date: false,
      directoryUrl: process.env.VUE_APP_REPOSITORY,
      formFilters: {
        created_at_after: null,
        created_at_before: null,
        delivery_date_after: null,
        delivery_date_before: null,
        organization: null,
        status: null,
        stockage_area: null,
        sub_total_price_max: null,
        sub_total_price_min: null,
        total_price_max: null,
        total_price_min: null,
        total_quantity_max: null,
        total_quantity_min: null,
        number: null,
      },
      haveDeliveryDate: false,
      loaded: false,
      numberSelected: 0,
      page: 1,
      perPage: 30,
      perPageOptions: [
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      productUrl: process.env.VUE_APP_PRODUCTS_API,
      rows: 0,
      searchInput: null,
      selectAll: false,
      sliderLeftActive: false,
      status: [],
      sub_total_price: false,
      total_price: false,
      total_quantity: false,
      transactions: [],
      nearToExpiration: false,
      manyInvoicesPayment: true,
      selectedList: [],
      is_sales: this.$route.params.sales === 'true',
      bulkPaymentSliderActive: false,
      loadedBulkPayment: true,
      submittedBulkPayment: false,
      bulkPaymentForm: {
        payment_date: new Date(),
        payment_method: null,
        note: null,
      },
      paymentMethodChoices: [
        { text: 'CB', value: 'cb' },
        { text: 'Chèque', value: 'bank_check' },
        { text: 'Espèce', value: 'cash' },
        { text: 'Virement bancaire', value: 'bank_transfer' },
      ],
    }
  },
  computed: {
    selectedTransactions() {
      return this.transactions
        .filter(({ selected }) => selected)
        .map(({ id }) => {
          return id
        })
    },

    searchTerms() {
      if (!this.searchInput) return []
      return this.searchInput
        .split(',')
        .map((term) => term.trim())
        .filter((term) => term.length > 0)
    },

    isMultiSearch() {
      return this.searchTerms.length > 1
    },
  },
  watch: {
    searchInput() {
      this.page = 1
      this.getTransactions()
    },

    activeFilters: {
      deep: true,
      handler() {
        this.page = 1
        this.getTransactions()
      },
    },

    formFilters: {
      deep: true,
      handler() {
        this.page = 1
        this.getTransactions()
      },
    },

    page() {
      this.getTransactions()
    },

    perPage() {
      this.page = 1
      this.getTransactions()
    },

    created_at() {
      this.activeFilters.created_at_after = this.created_at
      this.activeFilters.created_at_before = this.created_at
    },

    // eslint-disable-next-line func-names
    'activeFilters.created_at_after': function () {
      this.created_at = this.activeFilters.created_at_after
    },

    total_quantity() {
      this.activeFilters.total_quantity_max = this.total_quantity
      this.activeFilters.total_quantity_min = this.total_quantity
    },

    // eslint-disable-next-line func-names
    'activeFilters.total_quantity_max': function () {
      this.total_quantity = this.activeFilters.total_quantity_max
    },

    delivery_date() {
      this.activeFilters.delivery_date_after = this.delivery_date
      this.activeFilters.delivery_date_before = this.delivery_date
    },

    // eslint-disable-next-line func-names
    'activeFilters.delivery_date_after': function () {
      this.delivery_date = this.activeFilters.delivery_date_after
    },

    total_price() {
      this.activeFilters.total_price_max = this.total_price
      this.activeFilters.total_price_min = this.total_price
    },

    // eslint-disable-next-line func-names
    'activeFilters.total_price_max': function () {
      this.total_price = this.activeFilters.total_price_max
    },

    sub_total_price() {
      this.activeFilters.sub_total_price_max = this.sub_total_price
      this.activeFilters.sub_total_price_min = this.sub_total_price
    },

    // eslint-disable-next-line func-names
    'activeFilters.sub_total_price_max': function () {
      this.sub_total_price = this.activeFilters.sub_total_price_max
    },

    nearToExpiration() {
      this.getTransactions()
    },
  },

  async mounted() {
    await this.$nextTick()
    await this.getTransactions()
    this.status = this.transactionClass.get_status()
  },

  methods: {
    async valideInvoiceStatus() {
      if (this.selectedTransactions.length) {
        await APIRequest.create(process.env.VUE_APP_COMMERCIAL_API, `${this.ressource}/bulk_status`, {
          status: 'accepted',
          ids: this.selectedTransactions,
        })
      }
      this.$toast.open('Status des factures validé')
      // reload page
      this.getTransactions()

      //this.manyInvoicesPayment = !this.manyInvoicesPayment

      //const invoiceGroup = await InvoiceGroup.create({ invoices: [...this.selectedTransactions] })
      // Send group to payment page
      //const route = this.$router.resolve({ name: 'invoice-payment-bulk', params: { id: invoiceGroup.id } })
      //window.open(route.href, '_blank', 'width=1300,height=1200')
    },

    openBulkPaymentModal() {
      this.bulkPaymentSliderActive = true
      this.bulkPaymentForm.payment_date = new Date()
      this.bulkPaymentForm.payment_method = null
      this.bulkPaymentForm.note = null
      this.submittedBulkPayment = false
    },

    closeBulkPaymentModal() {
      this.bulkPaymentSliderActive = false
      this.submittedBulkPayment = false
      this.$v.bulkPaymentForm.$reset()
    },

    async submitBulkPayment() {
      this.submittedBulkPayment = true
      this.$v.bulkPaymentForm.$touch()

      if (this.$v.bulkPaymentForm.$invalid) {
        FunctionHelpers.formErrorModal()
        return
      }

      this.loadedBulkPayment = false

      try {
        // Récupérer les détails des factures sélectionnées pour obtenir les montants restants
        const invoicePromises = this.selectedTransactions.map((invoiceId) =>
          this.transactionClass.getById(invoiceId, {
            params: { fields: ['id', 'number', 'left_to_pay', 'status'] },
          }),
        )

        const invoices = await Promise.all(invoicePromises)

        // Créer un paiement pour chaque facture avec son montant restant
        const paymentPromises = invoices.map((invoice) => {
          const paymentForm = {
            invoice: invoice.id,
            amount: invoice.left_to_pay,
            payment_date: this.bulkPaymentForm.payment_date,
            payment_method: this.bulkPaymentForm.payment_method,
            note: this.bulkPaymentForm.note,
            payment_status: 'completed',
          }
          return InvoicePayment.create(paymentForm)
        })

        await Promise.all(paymentPromises)

        // Valider automatiquement les factures qui ne sont pas encore acceptées
        const invoicesToValidate = invoices
          .filter((invoice) => invoice.status !== 'accepted')
          .map((invoice) => invoice.id)

        if (invoicesToValidate.length > 0) {
          await APIRequest.create(process.env.VUE_APP_COMMERCIAL_API, `${this.ressource}/bulk_status`, {
            status: 'accepted',
            ids: invoicesToValidate,
          })
        }

        this.$toast.open({
          message: `${invoices.length} paiement(s) ajouté(s) avec succès${
            invoicesToValidate.length > 0 ? ` et ${invoicesToValidate.length} facture(s) validée(s)` : ''
          }`,
          type: 'success',
          position: 'top-right',
        })

        // Fermer le modal et recharger les données
        this.closeBulkPaymentModal()
        await this.getTransactions()

        // Désélectionner toutes les factures
        this.selectAll = false
        this.selectedAll()
      } catch (error) {
        this.$toast.open({
          message: "Erreur lors de l'ajout des paiements",
          type: 'error',
          position: 'top-right',
        })
      } finally {
        this.loadedBulkPayment = true
      }
    },

    selectedAll() {
      if (!this.selectAll) {
        this.transactions.forEach((transaction) => {
          transaction.selected = false
        })
        this.numberSelected = 0
        this.selectedList = []
      } else {
        this.transactions.forEach((transaction) => {
          transaction.selected = true
        })
        this.numberSelected = this.transactions.length
        this.selectedList = this.transactions.map((transaction) => transaction.id)
      }
    },

    selectAllSearchResults() {
      // Sélectionne automatiquement tous les résultats de la recherche multiple
      this.transactions.forEach((transaction) => {
        if (transaction.payment_status !== 'paid') {
          transaction.selected = true
        }
      })
      this.numberSelected = this.transactions.filter((t) => t.selected).length
      this.selectedList = this.transactions.filter((t) => t.selected).map((t) => t.id)

      this.$toast.open({
        message: `${this.numberSelected} facture(s) sélectionnée(s)`,
        type: 'success',
        position: 'top-right',
      })
    },

    getDistantValue(object, name) {
      if (object && object[name]) {
        return object[name]
      }
      return '-'
    },

    async getTransactions() {
      this.loaded = false
      const additional = this.nearToExpiration ? { near_expiration: true } : {}

      // Gestion de la recherche multiple avec virgules
      let searchParam = this.searchInput
      let multiSearchParams = {}

      if (this.isMultiSearch) {
        // Pour la recherche multiple, on utilise le paramètre number__in
        multiSearchParams = {
          number__in: this.searchTerms.join(','),
        }
        searchParam = '' // On vide la recherche standard
      }

      const requestParams = FunctionHelpers.createRequestParams(
        this.formFilters,
        this.activeFilters,
        this.page,
        searchParam,
      )

      // Champs de base nécessaires pour toutes les transactions
      const baseFields = ['id', 'number', 'organization_object', 'created_at', 'status', 'company']

      // Champs conditionnels selon le type de transaction
      const conditionalFields = []

      if ('expiration_date' in this.transactionClass.get_form()) {
        conditionalFields.push('expiration_date')
      }

      if (this.transactionClass.get_form().total_quantity) {
        conditionalFields.push('total_quantity')
      }

      if (this.transactionClass.get_form().total_price) {
        conditionalFields.push('total_price')
      }

      // Champs spécifiques aux factures
      if (this.ressource === 'invoices') {
        conditionalFields.push('payment_status', 'is_periodic', 'periodic_day')
      }

      ;[this.transactions, this.rows] = await this.transactionClass.get({
        params: {
          ...requestParams,
          ...this.additionalParams,
          ...additional,
          ...multiSearchParams,
          is_sales: this.is_sales,
          fields: [...baseFields, ...conditionalFields],
          page_size: this.perPage,
        },
      })
      this.loaded = true
      this.transactions = this.transactions.map((item) => {
        return { ...item, selected: this.selectedList.includes(item.id) }
      })
      this.selectAll = this.rows === this.transactions.filter((item) => item.selected).length
    },

    async duplicateTransaction(transactionId) {
      await APIRequest.create(process.env.VUE_APP_COMMERCIAL_API, `${this.ressource}/${transactionId}/duplicate`)
      await this.getTransactions()
      this.$toast.open('Duplication effectué')
    },
    goToTransactionCreate() {
      this.$router.push({ name: `${this.ressource.slice(0, this.ressource.length - 1)}-create` })
    },

    goToTransactionDetail(id) {
      this.$router.push({
        name: this.ressource.slice(0, this.ressource.length - 1),
        params: { id },
      })
    },

    goToTransactionEdit(id) {
      this.$router.push({
        name: `${this.ressource.slice(0, this.ressource.length - 1)}-modify`,
        params: { id },
      })
    },
    goToTransactionView(transaction) {
      const url = this.$router.resolve({
        name: `${this.ressource.slice(0, this.ressource.length - 1)}-public`,
        params: { id: transaction.id, company: transaction.company },
      })
      window.open(url.href, '_blank')
    },

    selectTransaction(transactionId) {
      const transaction = this.transactions.find((t) => t.id === transactionId)
      if (!transaction) return

      if (transaction.selected) {
        this.numberSelected += 1
        this.selectedList.push(transactionId)
      } else {
        this.numberSelected -= 1
        const index = this.selectedList.indexOf(transactionId)
        if (index > -1) {
          this.selectedList.splice(index, 1)
        }
      }
    },

    searchedFilter(search) {
      return search.includes(this.searchFilter.toLowerCase())
    },

    formatStatus(value) {
      return this.transactionClass.get_status().find((status) => status.value === value)?.text
    },

    formatColor(status) {
      return this.colors[status]
    },

    formatPaymentStatus(value) {
      return this.transactionClass.get_payment_status().find((item) => item.value === value).text
    },

    formatPaymentColor(value) {
      return this.transactionClass.get_payment_colors()[value]
    },

    scope(transaction) {
      const transactions = {
        credits: { status: 'pending', scope: 'credit' },
        'delivery-notes': { status: 'waiting', scope: 'deliverynote' },
        invoices: { status: 'pro_format', scope: 'invoice' },
        'product-returns': { status: 'waiting', scope: 'productreturn' },
        'purchase-orders': { status: 'active', scope: 'purchaseorder' },
        quotations: { status: 'pending', scope: 'quotation' },
        refunds: { status: 'pending', scope: 'refund' },
      }
      return (
        ((transaction.user === JSON.parse(localStorage.getItem('user_object')).uuid &&
          this.$hidderComponent(`${transactions[this.ressource].scope}:update[owner]`, false)) ||
          this.$hidderComponent(`${transactions[this.ressource].scope}:full`, false)) &&
        transaction.status === transactions[this.ressource].status
      )
    },
  },
}
</script>

<style scoped></style>
